import React from 'react';
import { ShieldIcon, Target, Users, Lightbulb } from 'lucide-react';
export function AboutPage() {
  return <div className="bg-black" data-id="element-166">
      {/* Hero Section */}
      <section className="relative w-full bg-gradient-to-b from-gray-900 to-black py-20 px-4 sm:px-6 lg:px-8" data-id="element-167">
        <div className="max-w-5xl mx-auto text-center" data-id="element-168">
          <h1 className="text-4xl sm:text-5xl font-bold mb-6" data-id="element-169">
            About Our <span className="text-[#4a7c59]" data-id="element-170">Mastermind</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-171">
            A community of service-oriented leaders—including Veterans, First
            Responders, Healthcare Professionals, and their families—dedicated
            to achieving financial independence through strategic investment and
            mutual support.
          </p>
        </div>
      </section>
      {/* Our Story */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-900" data-id="element-172">
        <div className="max-w-5xl mx-auto" data-id="element-173">
          <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-174">Our Story</h2>
          <div className="bg-black p-8 rounded-lg border border-[#4a7c59]" data-id="element-175">
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-176">
              The Tactical Investor Mastermind was founded by former Marine
              Corps Officer, Greg Namrow, who recognized the need for a structured,
              mission-focused approach to building wealth.
            </p>
            <p className="text-lg text-gray-300 leading-relaxed mt-4" data-id="element-177">
              Drawing from our experiences in the military, emergency services,
              healthcare, and public safety, we've created a community that
              emphasizes the same strategic planning, precise execution, and
              unwavering accountability that defines our service careers.
            </p>
          </div>
        </div>
      </section>
      {/* What Sets Us Apart */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-black" data-id="element-178">
        <div className="max-w-5xl mx-auto" data-id="element-179">
          <h2 className="text-3xl font-bold mb-12 text-center" data-id="element-180">
            What Sets Us Apart
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-181">
            <div className="bg-gray-900 p-6 rounded-lg border-l-4 border-[#4a7c59]" data-id="element-182">
              <div className="flex items-center mb-4" data-id="element-183">
                <ShieldIcon className="h-6 w-6 text-[#4a7c59] mr-3" data-id="element-184" />
                <h3 className="text-xl font-bold" data-id="element-185">
                  Service-Oriented Excellence
                </h3>
              </div>
              <p className="text-gray-300" data-id="element-186">
                Our community is built on the values and principles that guide
                service professionals in their dedication to others, whether in
                uniform, scrubs, or turnout gear.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg border-l-4 border-[#4a7c59]" data-id="element-187">
              <div className="flex items-center mb-4" data-id="element-188">
                <Target className="h-6 w-6 text-[#4a7c59] mr-3" data-id="element-189" />
                <h3 className="text-xl font-bold" data-id="element-190">Strategic Focus</h3>
              </div>
              <p className="text-gray-300" data-id="element-191">
                We apply the same precision and discipline from our service
                careers to investment strategies, ensuring clear objectives and
                measurable results.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg border-l-4 border-[#4a7c59]" data-id="element-192">
              <div className="flex items-center mb-4" data-id="element-193">
                <Users className="h-6 w-6 text-[#4a7c59] mr-3" data-id="element-194" />
                <h3 className="text-xl font-bold" data-id="element-195">Unified Community</h3>
              </div>
              <p className="text-gray-300" data-id="element-196">
                Our members support each other with the same dedication and
                camaraderie found in service professions, creating a powerful
                network for growth.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg border-l-4 border-[#4a7c59]" data-id="element-197">
              <div className="flex items-center mb-4" data-id="element-198">
                <Lightbulb className="h-6 w-6 text-[#4a7c59] mr-3" data-id="element-199" />
                <h3 className="text-xl font-bold" data-id="element-200">Continuous Growth</h3>
              </div>
              <p className="text-gray-300" data-id="element-201">
                We emphasize ongoing education and skill development, helping
                service professionals build wealth while maintaining their
                commitment to others.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#4a7c59]" data-id="element-202">
        <div className="max-w-4xl mx-auto text-center" data-id="element-203">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-204">
            Ready to Join Our Mission?
          </h2>
          <p className="text-xl mb-10" data-id="element-205">
            Take the first step towards financial independence with fellow
            service-oriented professionals.
          </p>
          <a href="https://forms.gle/G6C1Q8Ypo6M7rVcA9" target="_blank" rel="noopener noreferrer" className="bg-white text-black hover:bg-gray-200 font-bold py-3 px-8 rounded-md text-lg inline-block" data-id="element-206">
            Apply Now
          </a>
        </div>
      </section>
    </div>;
}